import { ModuleOperation } from '@/api/operations/models/module-operation'
import { UIComponentCustomConfigRequest } from '@/api/services/common/ui-component/custom-config/ui-component-custom-config.dto'
import { uiComponentCustomConfigService } from '@/api/services/common/ui-component/custom-config/ui-component-custom-config.service'
import i18n from '@/lang/i18n'
import { DashboardModuleSection, DashboardModuleSectionsWidgets, DashboardModuleUIComponentState } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { DashboardModuleUiComponent } from '@/modules/dashboard-module/store/dashboard-store.model'
import { HelperUtils } from '@/shared/util/helper-utils'
import { store } from '@/store/store'
import { ActionPayload } from 'vuex'

export const getWidgetSections = (): DashboardModuleSectionsWidgets[] => ([
    // {
    //     id: DashboardModuleSection.ALL,
    //     text: i18n.tc('dashboard.widget.category.general')
    // },
    {
        id: DashboardModuleSection.CLINICAL,
        text: i18n.tc('dashboard.widget.category.requests')
    },
    {
        id: DashboardModuleSection.REGISTRY,
        text: i18n.tc('dashboard.widget.category.registry')
    },
    {
        id: DashboardModuleSection.REQUEST,
        text: i18n.tc('dashboard.widget.category.requestBox')
    },
    {
        id: DashboardModuleSection.GROSSING,
        text: i18n.tc('dashboard.widget.category.grossing')
    },
    {
        id: DashboardModuleSection.DIAGNOSIS,
        text: i18n.tc('dashboard.widget.category.diagnosis')
    },
    {
        id: DashboardModuleSection.LABORATORY,
        text: i18n.tc('dashboard.widget.category.laboratory')
    },
    {
        id: DashboardModuleSection.INCIDENTS,
        text: i18n.tc('dashboard.widget.category.incidents')
    },
    {
        id: DashboardModuleSection.WASTE,
        text: i18n.tc('dashboard.widget.category.waste')
    }
])

export const getWidgetSectionAllWidgetsOption = (): DashboardModuleSectionsWidgets[] => ([
    {
        id: DashboardModuleSection.ALL,
        text: i18n.tc('dashboard.widget.category.allWidgets')
    }
])

export const hasSectionAccess = (section: DashboardModuleSection): boolean => {
    switch (section) {
    case DashboardModuleSection.CLINICAL:
        return HelperUtils.hasModuleAccess(ModuleOperation.PETITIONER)
    case DashboardModuleSection.REQUEST:
        return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY_REQUEST)
    case DashboardModuleSection.REGISTRY:
        return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY)
    case DashboardModuleSection.GROSSING:
        return HelperUtils.hasModuleAccess(ModuleOperation.GROSSING)
    case DashboardModuleSection.WASTE:
        return HelperUtils.hasModuleAccess(ModuleOperation.WASTE)
    case DashboardModuleSection.INCIDENTS:
        return HelperUtils.hasModuleAccess(ModuleOperation.INCIDENT)
    case DashboardModuleSection.DIAGNOSIS:
        return HelperUtils.hasModuleAccess(ModuleOperation.DIAGNOSE)
    case DashboardModuleSection.LABORATORY:
        return HelperUtils.hasModuleAccess(ModuleOperation.LABORATORY)
    default:
        return false
    }
}

export const dashboardModuleGetUIComponent = (): DashboardModuleUiComponent => (store.getters['dashboard/uiComponent'])

export const dashboardModuleSaveUIComponent = async (): Promise<void> => {
    const uiComponent = dashboardModuleGetUIComponent()
    const laboratoryId = store.getters.labId
    const customConfigRequest: UIComponentCustomConfigRequest<DashboardModuleUIComponentState> = {
        config: {
            pendingArea: store.getters['dashboard/pendingArea'],
            chartArea: store.getters['dashboard/chartArea'],
            interestingDataArea: store.getters['dashboard/interestingDataArea'],
            utilitiesArea: store.getters['dashboard/utilitiesArea']
        }
    }
    if (uiComponent.id !== null) {
        await uiComponentCustomConfigService.update<DashboardModuleUIComponentState>(
            uiComponent.name,
            customConfigRequest,
            uiComponent.id,
            laboratoryId
        )
    } else {
        const response = await uiComponentCustomConfigService.create<DashboardModuleUIComponentState>(
            uiComponent.name,
            customConfigRequest,
            laboratoryId
        )
        if (response) {
            await store.dispatch('dashboard/setIdUIComponent', response.id)
        }
    }
}
